import React from 'react'
import Button from './ui/Button'

export default function ContactBanner() {
    return (
        <div className='bg-grey px-lg-6 px-4 d-flex justify-content-center pt-3 mb-3'>
            <Button text={'Kontakta oss'} link={'kontakt'} />
        </div>
    )
}